<mat-form-field *ngIf="largeScreen" style="width: 30vw;">
  <mat-chip-list #chipList>
    <mat-chip
      *ngFor="let filter of filters"
      [selectable]="selectable"
      [removable]="removable"
      (removed)="remove(filter.field)">
      {{ filter.field + (filter.field === '' ? '"' : ': "') + filter.value + '"' }}
      <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
    </mat-chip>
    <input
      [placeholder]="this.translations['table-search.search']"
      #filterInput
      [formControl]="fieldCtrl"
      [matAutocomplete]="auto"
      [matChipInputFor]="chipList"
      matChipInputAddOnBlur="false"
      [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
      (matChipInputTokenEnd)="add($event)"     
      >
  </mat-chip-list>
  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
    <mat-option *ngFor="let field of filteredFields | async" [value]="field">
      {{ setOptionValue(field) }}
    </mat-option>
  </mat-autocomplete>
</mat-form-field>

